import styled from 'styled-components';

// VerificationsContainer styled components

const StyledVerificationsContainer = styled.div`
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2);
    background: white;
`;

const StyledContainerWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-start;
    @media (max-width: 980px) {
        display: block;
        border: ${({ theme }) => `1px solid ${theme.gray8}`};
        border-top: none;
        margin: 0px 10px 10px 10px;
        padding: 20px 10px 10px 10px;
        width: 98%;
    }
`;

const StyledDetailsContainer = styled.div`
    padding: 20px;
    margin: 0 auto;
    width: 75%;
    font-family: ${({ theme }) => theme.fontFamily};
    border-left: ${({ theme }) => `1px solid ${theme.gray8}`};

    .header {
        padding: 0 10px;
    }

    @media (max-width: 980px) {
        width: 100%;
        border: ${({ theme }) => `1px solid ${theme.gray8}`};
    }
`;

const StyledVLPContainer = styled.div`
    .header-container {
        padding: 0 !important;
        background: ${({ theme }) => `${theme.defaultWhite} !important`};
        width: fit-content;
    }
    .header {
        padding-left: 0;
        color: ${({ theme }) => theme.primaryMain};
        font-weight: 600;
    }
    label {
        display: inline-block;
        margin-bottom: 0;
        line-height: 1;
    }
`;

const StyledVLPHeader = styled.div`
    margin: 15px 0;
    font-weight: bold;
`;

const StyledVLPAccordianBody = styled.div`
    border:  ${({ theme }) => `1px solid ${theme.gray8}`};
    margin: 15px;
`;

const StyledHeader = styled.h3`
    padding: 10px;
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 30px;
    background: ${({ theme }) => theme.gray10};
`;

const StyledSubheaderContainer = styled.div`
    display: flex;
    margin-left: 25%;
    height: 40px;
    width: 75%;
    border-bottom: ${({ theme }) => `1px solid ${theme.gray8}`};
    @media (max-width: 980px) {
        width: 98%;
        margin-left: 10px;
    }
`;

const StyledSubheader = styled.h3`
    padding: 10px;
    font-weight: 300;
    height: 40px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border: ${({ theme }) => `1px solid ${theme.gray8}`};
    border-bottom: ${({ theme }) => `1px solid ${theme.defaultWhite}`};
    background: ${({ theme }) => theme.defaultWhite};
`;

const StyledBackButtonWrapper = styled.div`
    padding-top: 20px;
`;

const StyledUserInfo = styled.div`
    width: 25%;
    padding-left: 10px;
    @media (max-width: 980px) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding-left: 0px;
    }
`;

const StyledAlertInfoContainer = styled.div`
    margin-bottom: 40px;
`;

const StyledAccordionContainer = styled.div`
    margin-bottom: 20px;
    position: relative;
    .accordion-panel-component {
        border: 0;
        border-radius: 0;
    }

    .header-container {
        padding: 10px;
        background: ${({ theme }) => theme.gray10};
    }

    .content {
        border-top: 0px;
        padding: 0;
    }

    .toggle-icon {
        text-decoration: none;
        color: ${({ theme }) => theme.primaryDark};
    }
`;

const StyledAccordionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    height: 100%;
`;

const StyledAccordionHeaderText = styled.div<{ isDocumentCategoryVerified: boolean }>`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    height: 100%;

    .icon {
        color: ${({ theme, isDocumentCategoryVerified }) =>
            isDocumentCategoryVerified ? theme.successMain : theme.dangerMain};
    }

    .verification-type {
        color: ${({ theme }) => theme.primaryDark};
        margin-top: 5px;
    }
`;

// VerificationsDocumentUpload styled components
const StyledUploadContainer = styled.div`
    padding: 8px 12px;
`;

const StyledHeaderContainer = styled.p`
    margin-top: 10px;
    margin-bottom: 10px;
`;

const StyledContainer = styled.div`
    border: 1px solid #dddde5;
    padding: 0 20px;
`;

const StyledUploadDocument = styled.div`
    display: flex;
    margin-top: 20px;
`;

const StyledSelfEmploymentMessage = styled.div`
    display: flex;
`;

const StyledLabel = styled.label<{ documentType: string }>`
    font-weight: 400;
    padding: 10px 16px;
    font-size: Small;
    background-color: ${({ theme }) => theme.defaultWhite};
    border-radius: 4px;
    cursor: ${({ documentType }) => (documentType ? 'pointer' : 'not-allowed')};
    width: fit-content;
    @media (max-width: 540px) {
        align-items: center;
        width: 100%;
    }
`;

const StyledInputUpload = styled.input`
    display: none !important;
`;

const StyledDisabledInput = styled.input`
    border: 0 !important;
    background: white !important;
    padding: 0px;
    width: 100%;
    cursor: pointer;
`;

const StyledInput = styled.div<{ isOrCondition: boolean; isNonIncomeDocument: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 14px 0px;
    align-items: ${({ isNonIncomeDocument }) => (isNonIncomeDocument ? 'center' : 'start')};
    justify-content: ${({ isOrCondition }) => (isOrCondition ? 'center' : 'start')};
    line-height: 1.6;
    @media (max-width: 540px) {
        align-items: center;
        width: 100%;
        padding: 0px;
    }
`;

const StyledAmountInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .amount-input-field {
        max-width: 250px;
        padding: 8px;

        @media (max-width: 639px) {
            width: 100%;
            max-width: 100%;
        }
    }
    
    .gi-input__label {
        @media (max-width: 639px) {
            width: 100%;
            max-width: 100%;
        }
    }
`;

const StyledDocumentButton = styled.div`
    max-width: 150px;
    width: 100%;

    .gi-button {
        text-transform: none;
        font-size: small;
    }
    
    @media (max-width: 639px) {
        max-width: 100%;
        margin-top: 10px;
    }
`;

const StyledLabelName = styled.label`
    font-weight: 400 !important;
    color: ${({ theme }) => theme.gray2};
    padding-right: 10px;
    text-align: right;
    @media (max-width: 639px) {
        text-align: left;
        width: 100%;
    }
`;

const StyledButton = styled.div<{ isIncomeVerificationType: boolean }>`
    width: 100%;
    display: flex;
    justify-content: end;
    padding-bottom: 25px;
    margin-top: 30px;

    @media (max-width: 639px) {
        flex-direction: column;
    }

    .gi-button {
        text-transform: none;
    }
`;

const StyledSubHeaderLabel = styled.span`
    .anchor-on-click {
        cursor: pointer;
        color: ${({ theme }) => theme.primaryMain} !important;
    }
`;

const StyledGrid = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const StyledTextCenter = styled.div`
    text-align: center;
    font-size: Large;
    img {
        width: 200px;
        height: 200px;
    }
`;

const StyledTextPin = styled.div`
    text-align: center;
    font-size: Medium;

    @media (max-width: 639px) {
        width: 100%;
    }
`;

const StyledMarginBottom = styled.div`
    margin-bottom: 20px;
    text-align: center;
`;

const StyledQRCodeContainer = styled.div`
    box-sizing: border-box;
    color: ${({ theme }) => theme.successMain};
    margin-bottom: 10px;
`;

const StyledLink = styled.a`
    color:  ${({ theme }) => theme.primaryDark} !important};
    cursor: pointer;
`;

const StyledButtonContainer = styled.div<{ isIncomeVerificationType: boolean }>`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    @media (max-width: 639px) {
        align-items: center;
        width: 100%;
    }
`;
const StyledButtonDMI = styled.div<{ documentType: string }>`
    font-weight: 400;
    color: ${({ theme, documentType }) => (documentType ? theme.gray2 : theme.gray8)};
    background-color: ${({ theme }) => theme.defaultWhite};
    border-radius: 4px;
    width: fit-content;

    @media (max-width: 639px) {
            width: 100%;
    }

    .gi-button.dmiActionButton {
        padding: 10px 16px;
        font-weight: 400 !important;
        text-transform: none;
        border: ${({ theme }) => `1px solid ${theme.gray6}`};
        color: ${({ theme, documentType }) => (documentType ? theme.gray2 : theme.gray8)};
        background-color: ${({ theme }) => theme.defaultWhite};
        font-size: Small;
        max-width: 220px;
        &:disabled {
            cursor: not-allowed !important;
            text-transform: none;
            border: ${({ theme }) => `1px solid ${theme.gray8} !important`};
            font-weight: 400 !important;
            padding: 12px 16px;
            width: fit-content;
            font-size: Small;
            @media (max-width: 639px) {
                align-items: center;
                width: 100%;
            }
        }
        &:hover {
            background-color: ${({ theme }) => theme.defaultWhite};
            color: ${({ theme, documentType }) => (documentType ? theme.gray2 : theme.gray8)};
        }
        @media (max-width: 639px) {
            align-items: center;
            width: 100% !important;
            max-width: 100%;
            margin-bottom: 0;
        }
    }
`;
const StyledAllowedFiles = styled.div`
    width: 100%;
    margin-top: 20px;
    color: ${({ theme }) => theme.gray2};
`;

const StyledAllowedFilesError = styled.div`
    width: 100%;
    margin-top: 10px;
    color: ${({ theme }) => theme.dangerMain};
`;

const StyledOverrideButton = styled.div`
    font-weight: 400;
    .gi-button.override-button {
        display: inline-flex;
        padding: 10px;
        color: white;
        text-transform: none;
        font-weight: 400 !important;
        @media (max-width: 639px) {
            width: 100%;
            position: relative;
        }
    }
`;

export {
    StyledVerificationsContainer,
    StyledContainerWrapper,
    StyledDetailsContainer,
    StyledHeader,
    StyledSubheaderContainer,
    StyledSubheader,
    StyledBackButtonWrapper,
    StyledUserInfo,
    StyledAlertInfoContainer,
    StyledAccordionContainer,
    StyledAccordionHeader,
    StyledAccordionHeaderText,
    StyledUploadContainer,
    StyledVLPContainer,
    StyledVLPHeader,
    StyledVLPAccordianBody,
    StyledHeaderContainer,
    StyledContainer,
    StyledUploadDocument,
    StyledLabel,
    StyledInputUpload,
    StyledDisabledInput,
    StyledInput,
    StyledAmountInput,
    StyledDocumentButton,
    StyledLabelName,
    StyledButton,
    StyledSubHeaderLabel,
    StyledGrid,
    StyledTextCenter,
    StyledTextPin,
    StyledMarginBottom,
    StyledQRCodeContainer,
    StyledLink,
    StyledButtonContainer,
    StyledButtonDMI,
    StyledAllowedFiles,
    StyledAllowedFilesError,
    StyledOverrideButton,
    StyledSelfEmploymentMessage,
};
